import React, { ReactNode } from 'react';
import Container from '@v2/shared/components/Container';

/**
 * headless: apps/topmags/layouts/MainLayout/Content.
 *
 * The white card the page sits on. `main` lives here rather than in Full because that
 * is where headless puts it, and because the card and the landmark are the same box.
 */
export default function Content({ children }: { children: ReactNode }) {
  return (
    <Container className="px-0 md:px-5">
      <main id="main" role="main" className="bg-white rounded-none md:rounded-lg p-5 min-h-[700px]">
        {children}
      </main>
    </Container>
  );
}
